import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer
      className="content-container"
      style={{
        padding: 'var(--space-8) 20px',
        borderTop: '1px solid var(--color-divider)',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 'var(--space-6)',
        justifyContent: 'space-between'
      }}
    >
      <div>
        <span
          style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 600,
            fontSize: '20px',
            letterSpacing: '.14em',
            padding: '2px 10px',
            background: 'var(--color-accent-900)',
            color: 'var(--color-bg)'
          }}
        >
          TALLY
        </span>
        <p
          className="text-muted"
          style={{
            fontSize: '13px',
            margin: '14px 0 0',
            maxWidth: '260px'
          }}
        >
          The paper book, done right. Built for Ghanaian shops and restaurants.
        </p>
      </div>

      <div style={{ display: 'flex', gap: 'var(--space-8)', flexWrap: 'wrap' }}>
        <div>
          <div
            style={{
              fontFamily: 'var(--font-heading)',
              fontWeight: 600,
              fontSize: '13px',
              marginBottom: '10px'
            }}
          >
            Talk to us
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '14px' }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#25D366">
                <path d="M12.04 2A9.9 9.9 0 0 0 2.13 11.9c0 1.75.46 3.45 1.32 4.95L2 22l5.3-1.38a9.9 9.9 0 0 0 4.74 1.2A9.9 9.9 0 0 0 22 11.9 9.9 9.9 0 0 0 12.04 2Z"/>
              </svg>
              WhatsApp \u00B7 024 000 0000
            </span>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92Z"/>
              </svg>
              Call \u00B7 030 000 0000
            </span>
          </div>
        </div>

        <div>
          <div
            style={{
              fontFamily: 'var(--font-heading)',
              fontWeight: 600,
              fontSize: '13px',
              marginBottom: '10px'
            }}
          >
            TALLY
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '14px' }}>
            <Link to="/#how-it-works" style={{ color: 'inherit', textDecoration: 'none' }}>
              How it works
            </Link>
            <Link to="/#benefits" style={{ color: 'inherit', textDecoration: 'none' }}>
              Benefits
            </Link>
            <Link to="/contact" style={{ color: 'inherit', textDecoration: 'none' }}>
              Book a demo
            </Link>
            <Link to="/#waitlist" style={{ color: 'inherit', textDecoration: 'none' }}>
              Waitlist
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
